import { Box, Grid2 as Grid } from "@mui/material";
import { OrganizationAccordion } from "./OrganizationAccordion";
import { CreateOrganizationWizard } from "./CreateOrganizationWizard";
import {
  createOrganizationWizardStepAtom,
  isCreateOrganizationModeAtom,
  isCreateOrganizationSuccessAtom,
  organizationWizardProfileAtom,
  organizationWizardWashTypesAtom,
  selectedOrgIdAtom,
  userAtom,
} from "../../atoms";
import { useAtom } from "jotai";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import { SadmCreateOrganizationRoute } from "../../routes";
import { Role } from "../../enums";
import { organizationMenus } from "./OrganizationMenus";

export const OrganizationDetail = () => {
  const params = useParams();
  const location = useLocation();
  const [user] = useAtom(userAtom);
  const [, setSelectedOrgId] = useAtom(selectedOrgIdAtom);
  const [isCreateOrganizationMode, setIsCreateOrganizationMode] = useAtom(
    isCreateOrganizationModeAtom,
  );
  const [, setWizardStep] = useAtom(createOrganizationWizardStepAtom);
  const [, setIsWizardSuccess] = useAtom(isCreateOrganizationSuccessAtom);
  const [, setWizardProfile] = useAtom(organizationWizardProfileAtom);
  const [, setWizardWashTypes] = useAtom(organizationWizardWashTypesAtom);

  useEffect(() => {
    if (
      location.pathname.split("/").pop() === SadmCreateOrganizationRoute.path
    ) {
      setIsCreateOrganizationMode(true);
      setSelectedOrgId(0);
      setWizardStep(0);
      setIsWizardSuccess(false);
      setWizardProfile(undefined);
      setWizardWashTypes([]);
    } else if (params.orgId && user && user.roleCode !== Role.Customer) {
      setSelectedOrgId(Number(params.orgId));
    }
  }, [location.pathname, params.orgId, user]);

  return (
    <Box
      sx={{
        minHeight: { xs: "100%", sm: "715px" },
        display: "flex",
        width: "100%",
        maxWidth: "100%",
        flexGrow: 1,
        overflow: "visible",
      }}
    >
      <Grid
        container
        direction={"column"}
        spacing={2}
        gap={0}
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: "auto",
          borderRadius: "10px",
          direction: "row",
          py: { xs: 0.5, sm: "1rem" },
          px: { xs: 0, sm: 0 },
          minWidth: 0,
        }}
      >
        {isCreateOrganizationMode ? (
          <CreateOrganizationWizard />
        ) : (
          organizationMenus
            .filter(
              (menu) =>
                (user?.roleCode === Role.SuperAdmin ||
                  user?.roleCode === Role.Admin ||
                  menu.name !== "integrations") &&
                (user?.roleCode === Role.SuperAdmin ||
                  menu.name !== "features"),
            )
            .map((menu, index) => (
              <OrganizationAccordion key={index} menu={menu} />
            ))
        )}
      </Grid>
    </Box>
  );
};
